'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface TrustMetric {
  icon: string;
  label: string;
  value: string;
  description: string;
}

const trustMetrics: TrustMetric[] = [
  {
    icon: 'CheckBadgeIcon',
    label: 'RERA Registered',
    value: 'UPRERAPRJ442214',
    description: 'Fully compliant with Real Estate Regulatory Authority',
  },
  {
    icon: 'HomeModernIcon',
    label: 'Units Sold',
    value: '847',
    description: 'Families have already invested in Godrej Sigma',
  },
  {
    icon: 'StarIcon',
    label: 'Customer Rating',
    value: '4.8/5',
    description: 'Based on 500+ verified customer reviews',
  },
  {
    icon: 'ClockIcon',
    label: 'Godrej Legacy',
    value: '125+ Years',
    description: 'Trusted name in Indian real estate',
  },
];

export default function TrustIndicatorBar() {
  const [isVisible, setIsVisible] = useState(false);
  const [animatedValues, setAnimatedValues] = useState<{ [key: string]: number }>({});

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsVisible(scrollPosition > 200);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isVisible) {
      const unitsSold = 847;
      const duration = 2000;
      const steps = 60;
      const increment = unitsSold / steps;
      let currentStep = 0;

      const timer = setInterval(() => {
        currentStep++;
        setAnimatedValues({
          unitsSold: Math.min(Math.floor(increment * currentStep), unitsSold),
        });

        if (currentStep >= steps) {
          clearInterval(timer);
        }
      }, duration / steps);

      return () => clearInterval(timer);
    }
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <div data-component-id="src/components/common/TrustIndicatorBar.tsx:80:4" data-component-path="src/components/common/TrustIndicatorBar.tsx" data-component-line="80" data-component-end-line="111" data-component-file="TrustIndicatorBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-card%20border-t%20border-b%20border-border%20py-4%20animate-in%20fade-in%20slide-in-from-top-4%20duration-500%22%7D" className="bg-card border-t border-b border-border py-4 animate-in fade-in slide-in-from-top-4 duration-500">
      <div data-component-id="src/components/common/TrustIndicatorBar.tsx:81:6" data-component-path="src/components/common/TrustIndicatorBar.tsx" data-component-line="81" data-component-end-line="110" data-component-file="TrustIndicatorBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-%5B1200px%5D%20mx-auto%20px-6%22%7D" className="max-w-[1200px] mx-auto px-6">
        <div data-component-id="src/components/common/TrustIndicatorBar.tsx:82:8" data-component-path="src/components/common/TrustIndicatorBar.tsx" data-component-line="82" data-component-end-line="109" data-component-file="TrustIndicatorBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20md%3Agrid-cols-4%20gap-4%22%7D" className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {trustMetrics.map((metric, index) => (
            <div data-component-id="src/components/common/TrustIndicatorBar.tsx:84:12" data-component-path="src/components/common/TrustIndicatorBar.tsx" data-component-line="84" data-component-end-line="107" data-component-file="TrustIndicatorBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20gap-3%20group%20cursor-pointer%22%7D"
              key={index}
              className="flex items-center gap-3 group cursor-pointer"
              title={metric.description}
            >
              <div data-component-id="src/components/common/TrustIndicatorBar.tsx:89:14" data-component-path="src/components/common/TrustIndicatorBar.tsx" data-component-line="89" data-component-end-line="96" data-component-file="TrustIndicatorBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex-shrink-0%20w-10%20h-10%20bg-primary%20rounded-full%20flex%20items-center%20justify-center%20group-hover%3Abg-accent%20transition-colors%20duration-250%22%7D" className="flex-shrink-0 w-10 h-10 bg-primary rounded-full flex items-center justify-center group-hover:bg-accent transition-colors duration-250">
                <Icon data-component-id="src/components/common/TrustIndicatorBar.tsx:90:16" data-component-path="src/components/common/TrustIndicatorBar.tsx" data-component-line="90" data-component-end-line="95" data-component-file="TrustIndicatorBar.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22className%22%3A%22text-primary-foreground%22%7D"
                  name={metric.icon as any}
                  size={20}
                  variant="solid"
                  className="text-primary-foreground"
                />
              </div>
              <div data-component-id="src/components/common/TrustIndicatorBar.tsx:97:14" data-component-path="src/components/common/TrustIndicatorBar.tsx" data-component-line="97" data-component-end-line="106" data-component-file="TrustIndicatorBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%22%7D" className="flex flex-col">
                <span data-component-id="src/components/common/TrustIndicatorBar.tsx:98:16" data-component-path="src/components/common/TrustIndicatorBar.tsx" data-component-line="98" data-component-end-line="100" data-component-file="TrustIndicatorBar.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22font-source%20text-xs%20text-textSecondary%22%7D" className="font-source text-xs text-textSecondary">
                  {metric.label}
                </span>
                <span data-component-id="src/components/common/TrustIndicatorBar.tsx:101:16" data-component-path="src/components/common/TrustIndicatorBar.tsx" data-component-line="101" data-component-end-line="105" data-component-file="TrustIndicatorBar.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22font-montserrat%20font-bold%20text-sm%20text-primary%22%7D" className="font-montserrat font-bold text-sm text-primary">
                  {metric.label === 'Units Sold' && animatedValues.unitsSold
                    ? animatedValues.unitsSold.toLocaleString()
                    : metric.value}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}